import { render, staticRenderFns } from "./RevenuePointSummary.vue?vue&type=template&id=2fb495b9"
import script from "./RevenuePointSummary.vue?vue&type=script&lang=js"
export * from "./RevenuePointSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports